<template>
    <div class="body bank-app">
        <Navbar :show-back-button="true" @back="goBack"/>
        
        <div class="profit-loss-container">

            <!-- Loading State -->
            <div v-if="loading" class="loading-state">
                <div class="spinner"></div>
                <p>در حال بارگیری اطلاعات...</p>
            </div>

            <!-- Error State -->
            <div v-else-if="error" class="error-state">
                <div class="error-icon">⚠️</div>
                <p>{{ error }}</p>
                <button @click="fetchData" class="retry-btn">تلاش مجدد</button>
            </div>

            <!-- Profit/Loss Cards -->
            <!-- <div v-else-if="dataLoaded" class="pl-grid">
                <div class="pl-card net-profit">
                    <div class="pl-card-header">
                        <span class="pl-card-icon">📈</span>
                        <span class="pl-card-label">سود یا زیان</span>
                    </div>
                    <div class="pl-card-value" :class="getProfitClass(netProfit)">
                        {{ formatCurrency(netProfit) }}
                    </div>
                </div>

                <div class="pl-card revenue">
                    <div class="pl-card-header">
                        <span class="pl-card-icon">💰</span>
                        <span class="pl-card-label">فروش</span>
                    </div>
                    <div class="pl-card-value revenue-color">
                        {{ formatCurrency(revenue) }}
                    </div>
                </div>

                <div class="pl-card cogs">
                    <div class="pl-card-header">
                        <span class="pl-card-icon">📦</span>
                        <span class="pl-card-label">بهای تمام شده کالای فروخته شده</span>
                    </div>
                    <div class="pl-card-value expense-color">
                        {{ formatCurrency(cogs) }}
                    </div>
                </div>

                <div class="pl-card income">
                    <div class="pl-card-header">
                        <span class="pl-card-icon">📊</span>
                        <span class="pl-card-label">درآمدها</span>
                    </div>
                    <div class="pl-card-value income-color">
                        {{ formatCurrency(income) }}
                    </div>
                </div>

                <div class="pl-card expenses">
                    <div class="pl-card-header">
                        <span class="pl-card-icon">📉</span>
                        <span class="pl-card-label">هزینه‌ها</span>
                    </div>
                    <div class="pl-card-value expense-color">
                        {{ formatCurrency(expenses) }}
                    </div>
                </div>
            </div> -->

            <!-- Records Section -->
            <div v-if="dataLoaded && rawData.length > 0" class="records-section">
                <div class="records-header">
                    <h3 class="records-title">📋 جزئیات حساب‌ها</h3>
                    <div class="records-controls">
                        <span class="records-count">{{ rawData.length }} رکورد</span>
                        <!-- <button @click="toggleTableVisibility" class="toggle-table-btn">
                            {{ showTable ? '🔽 مخفی کردن' : '🔼 نمایش جزئیات' }}
                        </button> -->
                    </div>
                </div>

                <!-- Desktop Table View -->
                <div v-if="showTable" class="table-wrapper desktop-view">
                    <table class="records-table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>کد حساب</th>
                                <th>عنوان حساب</th>
                                <th class="amount-column">بدهکار</th>
                                <th class="amount-column">بستانکار</th>
                                <th class="amount-column">مانده</th>
                                <th>نوع</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in paginatedData" :key="index" :class="getRowClass(item)">
                                <td>{{ index + 1 + (currentPage - 1) * pageSize }}</td>
                                <td class="code-cell">{{ item.HandCode }}</td>
                                <td class="title-cell">{{ item.HandTitle }}</td>
                                <td class="amount-column bed-amount">{{ formatCurrency(item.MandeLast_Bed) }}</td>
                                <td class="amount-column bes-amount">{{ formatCurrency(item.MandeLast_Bes) }}</td>
                                <td class="amount-column balance-amount" :class="getBalanceClass(item)">
                                    {{ formatCurrency(Math.abs(getBalance(item))) }}
                                </td>
                                <td>
                                    <span class="account-type-badge" :class="getAccountTypeClass(item)">
                                        {{ getAccountType(item) }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot v-if="rawData.length > 0">
                            <tr class="summary-row">
                                <td colspan="3" class="summary-label">جمع کل</td>
                                <td class="amount-column summary-bed">{{ formatCurrency(totalBed) }}</td>
                                <td class="amount-column summary-bes">{{ formatCurrency(totalBes) }}</td>
                                <td class="amount-column summary-balance">{{ formatCurrency(Math.abs(totalBalance)) }}</td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>

                    <!-- Pagination -->
                    <!-- <div v-if="totalPages > 1" class="pagination">
                        <button @click="previousPage" :disabled="currentPage === 1" class="page-btn">
                            قبلی
                        </button>
                        <span class="page-info">صفحه {{ currentPage }} از {{ totalPages }}</span>
                        <button @click="nextPage" :disabled="currentPage === totalPages" class="page-btn">
                            بعدی
                        </button>
                    </div> -->
                </div>

                <!-- Mobile Card View -->
                <div v-if="showTable" class="mobile-view">
                    <!-- Regular Records -->
                    <div 
                        v-for="(item, index) in regularRecords" 
                        :key="'record-' + index" 
                        class="record-card" 
                        :class="getRowClass(item)"
                    >
                        <div class="card-header">
                            <span class="card-index">#{{ index + 1 + (currentPage - 1) * pageSize }}</span>
                            <span class="card-type-badge" :class="getAccountTypeClass(item)">
                                {{ getAccountType(item) }}
                            </span>
                        </div>
                        <div class="card-body">
                            <div class="card-row">
                                <span class="card-value title">{{ item.HandTitle }}</span>
                            </div>
                            <div class="card-row">
                                <span class="card-label">بدهکار</span>
                                <span class="card-value amount bed">{{ formatCurrency(item.MandeLast_Bed) }}</span>
                            </div>
                            <div class="card-row">
                                <span class="card-label">بستانکار</span>
                                <span class="card-value amount bes">{{ formatCurrency(item.MandeLast_Bes) }}</span>
                            </div>
                            <div class="card-row balance-row">
                                <span class="card-label">مانده</span>
                                <span class="card-value amount balance" :class="getBalanceClass(item)">
                                    {{ formatCurrency(Math.abs(getBalance(item))) }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- Summary/Total Card - Highlighted and Bold -->
                    <div v-if="summaryData" class="record-card summary-card">
                        <div class="card-header summary-header">
                            <span class="card-index summary-icon">📊</span>
                            <span class="card-type-badge type-summary">سود و زیان</span>
                        </div>
                        <div class="card-body summary-body">
                            <div class="card-row">
                                <span class="card-value title summary-title">{{ summaryData.HandTitle }}</span>
                            </div>
                            <div class="card-row">
                                <span class="card-label summary-label">بدهکار</span>
                                <span class="card-value amount bed summary-amount">{{ formatCurrency(summaryData.MandeLast_Bed) }}</span>
                            </div>
                            <div class="card-row">
                                <span class="card-label summary-label">بستانکار</span>
                                <span class="card-value amount bes summary-amount">{{ formatCurrency(summaryData.MandeLast_Bes) }}</span>
                            </div>
                            <div class="card-row balance-row summary-balance-row">
                                <span class="card-label summary-label">مانده کل</span>
                                <span class="card-value amount balance summary-balance" :class="getBalanceClass(summaryData)">
                                    {{ formatCurrency(Math.abs(getBalance(summaryData))) }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Empty State -->
            <div v-else-if="!loading && !error && !dataLoaded" class="empty-state">
                <div class="empty-icon">📊</div>
                <h3>داده‌ای برای نمایش وجود ندارد</h3>
                <p>لطفاً اطلاعات مالی را بارگیری کنید</p>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import Navbar from '@/components/Navbar.vue'
import { employerService } from '@/services/api'

export default {
    name: 'ProfitLossDashboard',
    components: {
        Navbar
    },
    setup() {
        const router = useRouter()
        
        // State
        const loading = ref(false)
        const error = ref(null)
        const dataLoaded = ref(false)
        const rawData = ref([])
        const showTable = ref(true)
        
        // Pagination
        const currentPage = ref(1)
        const pageSize = ref(10)
        
        // Data
        const netProfit = ref(0)
        const revenue = ref(0)
        const cogs = ref(0)
        const income = ref(0)
        const expenses = ref(0)

        // Computed properties for table
        const totalPages = computed(() => {
            return Math.ceil(rawData.value.length / pageSize.value)
        })

        const paginatedData = computed(() => {
            // const start = (currentPage.value - 1) * pageSize.value
            // const end = start + pageSize.value
            return rawData.value
        })

        const totalBed = computed(() => {
            return rawData.value.reduce((sum, item) => sum + (item.MandeLast_Bed || 0), 0)
        })

        const totalBes = computed(() => {
            return rawData.value.reduce((sum, item) => sum + (item.MandeLast_Bes || 0), 0)
        })

        const totalBalance = computed(() => {
            return totalBes.value - totalBed.value
        })

        // Methods
        const goBack = () => {
            router.push('/employer/dashboard')
        }

        const toggleTableVisibility = () => {
            showTable.value = !showTable.value
        }

        const getBalance = (item) => {
            return (item.MandeLast_Bes || 0) - (item.MandeLast_Bed || 0)
        }

        const getBalanceClass = (item) => {
            const balance = getBalance(item)
            if (balance > 0) return 'credit-balance'
            if (balance < 0) return 'debit-balance'
            return 'zero-balance'
        }

        const getRowClass = (item) => {
            const balance = getBalance(item)
            if (balance > 0) return 'credit-row'
            if (balance < 0) return 'debit-row'
            return 'zero-row'
        }

        const getAccountType = (item) => {
            const total = (item.MandeLast_Bes || 0) - (item.MandeLast_Bed || 0)
            if (total > 0) {
                return 'درآمدی'
            } else if (total < 0) {
                return 'هزینه‌ای'
            } else {
                return '-'
            }
        }

        const getAccountTypeClass = (item) => {
            const type = getAccountType(item)
            if (type === 'درآمدی') return 'type-income'
            if (type === 'هزینه‌ای') return 'type-expense'
            return 'type-other'
        }

        // Check if this is the net profit/loss account
        const isNetProfitAccount = (handCode, handTitle) => {
            return handCode === '99,99,99' || handTitle.includes('مانده سود و زيان')
        }

        // Process the raw data to calculate financial metrics
        const processData = (data) => {
            let totalRevenue = 0
            let totalExpenses = 0
            let netProfitValue = 0
            let cogsValue = 0
            
            data.forEach(item => {
                const { HandCode, HandTitle, MandeLast_Bed, MandeLast_Bes } = item
                
                // Skip if both are zero
                if (MandeLast_Bed === 0 && MandeLast_Bes === 0) return
                
                // Check for net profit account
                if (isNetProfitAccount(HandCode, HandTitle)) {
                    netProfitValue = MandeLast_Bed - MandeLast_Bes
                    return
                }
                
                // Check for COGS
                if (HandTitle.includes('بهاي تمام شده كالاي فروش رفته') || 
                    HandTitle.includes('بهاي تمام شده كالاي توليد شده')) {
                    cogsValue += MandeLast_Bed
                    totalExpenses += MandeLast_Bed
                    return
                }
                
                // Calculate total for this account (Bes - Bed)
                const total = MandeLast_Bes - MandeLast_Bed
                
                // If total is positive, it's revenue/income
                if (total > 0) {
                    totalRevenue += total
                } 
                // If total is negative, it's expense
                else if (total < 0) {
                    totalExpenses += Math.abs(total)
                }
            })
            
            // If net profit is not directly provided, calculate it
            if (netProfitValue === 0) {
                netProfitValue = totalRevenue - totalExpenses
            }
            
            return {
                netProfit: netProfitValue,
                revenue: totalRevenue,
                cogs: cogsValue,
                income: totalRevenue,
                expenses: totalExpenses
            }
        }

        const fetchData = async () => {
            loading.value = true
            error.value = null

            try {
                const response = await employerService.getTarazSood(1, 3)
                
                if (response.data && Array.isArray(response.data)) {
                    rawData.value = response.data
                    const metrics = processData(response.data)
                    
                    netProfit.value = metrics.netProfit
                    revenue.value = metrics.revenue
                    cogs.value = metrics.cogs
                    income.value = metrics.income
                    expenses.value = metrics.expenses
                    
                    dataLoaded.value = true
                } else if (response.data && response.data.success) {
                    const data = response.data.data || response.data.result || []
                    if (Array.isArray(data)) {
                        rawData.value = data
                        const metrics = processData(data)
                        netProfit.value = metrics.netProfit
                        revenue.value = metrics.revenue
                        cogs.value = metrics.cogs
                        income.value = metrics.income
                        expenses.value = metrics.expenses
                        dataLoaded.value = true
                    }
                } else {
                    throw new Error('Invalid data format received from server')
                }

            } catch (err) {
                console.error('Error fetching profit/loss data:', err)
                error.value = err.response?.data?.detail || err.message || 'خطا در دریافت اطلاعات'
            } finally {
                loading.value = false
            }
        }

        const formatCurrency = (amount) => {
            if (!amount && amount !== 0) return '۰'
            return new Intl.NumberFormat('fa-IR').format(Math.round(amount))
        }

        const getProfitClass = (value) => {
            if (value > 0) return 'positive'
            if (value < 0) return 'negative'
            return 'zero'
        }

        const previousPage = () => {
            if (currentPage.value > 1) {
                currentPage.value--
            }
        }

        const nextPage = () => {
            if (currentPage.value < totalPages.value) {
                currentPage.value++
            }
        }

// Get regular records (excluding the last one if it's a summary)
const regularRecords = computed(() => {
    const data = paginatedData.value
    if (data.length === 0) return []
    
    // If the last item is the net profit account or summary, exclude it
    const lastItem = data[data.length - 1]
    if (isNetProfitAccount(lastItem.HandCode, lastItem.HandTitle)) {
        return data.slice(0, -1)
    }
    return data
})

// Get summary data (last record or calculated totals)
const summaryData = computed(() => {
    const data = paginatedData.value
    if (data.length === 0) return null
    
    const lastItem = data[data.length - 1]
    
    return lastItem
})

        onMounted(() => {
            fetchData()
        })

        return {
            loading,
            error,
            dataLoaded,
            rawData,
            netProfit,
            revenue,
            cogs,
            income,
            expenses,
            showTable,
            currentPage,
            pageSize,
            totalPages,
            paginatedData,
            totalBed,
            totalBes,
            totalBalance,
            goBack,
            fetchData,
            formatCurrency,
            getProfitClass,
            getBalance,
            getBalanceClass,
            getRowClass,
            getAccountType,
            getAccountTypeClass,
            toggleTableVisibility,
            previousPage,
            nextPage,
            regularRecords,
            summaryData
        }
    }
}
</script>

<style scoped>
.bank-app {
    min-height: 100vh;
    background: var(--bg);
    padding: 20px;
    direction: rtl;
    margin-bottom: 45px;
}

.profit-loss-container {
    max-width: 1400px;
    margin: 0 auto;
}

/* Loading State */
.loading-state {
    text-align: center;
    padding: 60px 20px;
}

.spinner {
    border: 4px solid var(--border);
    border-top: 4px solid var(--primary);
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
    margin: 0 auto 16px;
}

/* Error State */
.error-state {
    text-align: center;
    padding: 40px 20px;
    background: #fff3cd;
    border-radius: 12px;
    border: 1px solid #ffc107;
}

.error-icon {
    font-size: 48px;
    margin-bottom: 12px;
}

.retry-btn {
    padding: 10px 24px;
    background: var(--primary);
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    transition: background 0.3s ease;
}

.retry-btn:hover {
    background: var(--primary-hover);
}

/* PL Grid */
.pl-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-bottom: 24px;
}

.pl-card {
    background: var(--card-bg);
    border-radius: 16px;
    padding: 20px;
    border: 1px solid var(--border);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.pl-card.net-profit {
    grid-column: 1 / -1;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
}

.pl-card.net-profit .pl-card-value {
    font-size: 32px;
}

.pl-card-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 8px;
}

.pl-card-icon {
    font-size: 20px;
}

.pl-card-label {
    font-size: 14px;
    color: var(--text-muted);
    font-weight: 500;
}

.pl-card-value {
    font-size: 24px;
    font-weight: 700;
    direction: ltr;
    text-align: right;
}

.pl-card-value.positive {
    color: #22c55e;
}

.pl-card-value.negative {
    color: #ef4444;
}

.revenue-color {
    color: #22c55e;
}

.expense-color {
    color: #ef4444;
}

.income-color {
    color: #3b82f6;
}

/* Records Section */
.records-section {
    margin-top: 8px;
}

.records-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background: var(--card-bg);
    border-radius: 12px;
    border: 1px solid var(--border);
    margin-bottom: 16px;
    flex-wrap: wrap;
    gap: 8px;
}

.records-title {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: var(--heading);
}

.records-controls {
    display: flex;
    align-items: center;
    gap: 12px;
}

.records-count {
    font-size: 13px;
    color: var(--text-muted);
}

.toggle-table-btn {
    padding: 6px 14px;
    border: 1px solid var(--border);
    border-radius: 8px;
    background: var(--bg);
    color: var(--text);
    cursor: pointer;
    font-size: 13px;
    transition: all 0.2s ease;
}

.toggle-table-btn:hover {
    background: var(--hover);
}

/* Desktop Table View */
.table-wrapper {
    overflow-x: auto;
    border-radius: 12px;
    border: 1px solid var(--border);
    background: var(--card-bg);
}

.records-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    min-width: 700px;
}

.records-table thead {
    background: var(--bg);
}

.records-table th {
    padding: 10px 14px;
    text-align: right;
    font-weight: 600;
    color: var(--text-muted);
    border-bottom: 2px solid var(--border);
    white-space: nowrap;
}

.records-table td {
    padding: 8px 14px;
    border-bottom: 1px solid var(--border);
}

.records-table tbody tr:hover {
    background: var(--hover);
}

.records-table .amount-column {
    font-variant-numeric: tabular-nums;
    direction: ltr;
    text-align: right;
    white-space: nowrap;
}

.records-table .bed-amount {
    color: #ef4444;
}

.records-table .bes-amount {
    color: #22c55e;
}

.records-table .balance-amount.debit-balance {
    color: #ef4444;
}

.records-table .balance-amount.credit-balance {
    color: #22c55e;
}

.records-table .balance-amount.zero-balance {
    color: var(--text-muted);
}

.records-table .code-cell {
    font-family: monospace;
    font-size: 12px;
    direction: ltr;
}

.records-table .title-cell {
    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* Account Type Badges */
.account-type-badge {
    padding: 2px 10px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 500;
    display: inline-block;
}

.type-income {
    background: #d1fae5;
    color: #065f46;
}

.type-expense {
    background: #fee2e2;
    color: #991b1b;
}

.type-other {
    background: var(--bg);
    color: var(--text-muted);
}

/* Row Classes */
.debit-row {
    border-right: 3px solid #ef4444;
}

.credit-row {
    border-right: 3px solid #22c55e;
}

.zero-row {
    border-right: 3px solid var(--border);
}

/* Summary Row */
.summary-row {
    background: var(--bg);
    font-weight: 600;
}

.summary-row td {
    border-top: 2px solid var(--border);
}

.summary-bed {
    color: #ef4444;
}

.summary-bes {
    color: #22c55e;
}

/* Pagination */
.pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    padding: 16px;
    border-top: 1px solid var(--border);
}

.page-btn {
    padding: 6px 16px;
    border: 1px solid var(--border);
    border-radius: 6px;
    background: var(--bg);
    color: var(--text);
    cursor: pointer;
    transition: all 0.2s ease;
}

.page-btn:hover:not(:disabled) {
    background: var(--hover);
    border-color: var(--primary);
}

.page-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
}

.page-info {
    font-size: 14px;
    color: var(--text-muted);
}

/* ===== MOBILE CARD VIEW ===== */
.mobile-view {
    display: none;
    flex-direction: column;
    gap: 12px;
    margin-top: 12px;
}

.record-card {
    background: var(--card-bg);
    border-radius: 12px;
    padding: 16px;
    border: 1px solid var(--border);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    transition: all 0.2s ease;
}

.record-card.debit-row {
    border-right: 4px solid #ef4444;
}

.record-card.credit-row {
    border-right: 4px solid #22c55e;
}

.record-card.zero-row {
    border-right: 4px solid var(--border);
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid var(--border);
}

.card-index {
    font-weight: 700;
    color: var(--primary);
    font-size: 14px;
}

.card-type-badge {
    padding: 2px 12px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 500;
}

.card-type-badge.type-income {
    background: #d1fae5;
    color: #065f46;
}

.card-type-badge.type-expense {
    background: #fee2e2;
    color: #991b1b;
}

.card-type-badge.type-other {
    background: var(--bg);
    color: var(--text-muted);
}

.card-body {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.card-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 0;
}

.card-label {
    font-size: 13px;
    color: var(--text-muted);
    font-weight: 500;
}

.card-value.title {
    font-size: 16px;
    font-weight: 600;
    color: var(--heading);
    text-align: right;
    line-height: 1.4;
}

.card-value.amount {
    font-size: 15px;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    direction: ltr;
}

.card-value.bed {
    color: #ef4444;
}

.card-value.bes {
    color: #22c55e;
}

.card-value.balance.debit-balance {
    color: #ef4444;
}

.card-value.balance.credit-balance {
    color: #22c55e;
}

.card-value.balance.zero-balance {
    color: var(--text-muted);
}

.balance-row {
    padding-top: 6px;
    margin-top: 4px;
    border-top: 1px solid var(--border);
}

/* Mobile Pagination */
.mobile-pagination {
    padding: 12px;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 992px) {
    .pl-grid {
        grid-template-columns: 1fr 1fr;
        gap: 12px;
    }

    .pl-card.net-profit {
        grid-column: 1;
    }

    .pl-card-value {
        font-size: 20px;
    }

    .pl-card.net-profit .pl-card-value {
        font-size: 26px;
    }
}

@media (max-width: 768px) {
    .bank-app {
        padding: 12px;
    }

    .pl-grid {
        grid-template-columns: 1fr 1fr;
        gap: 10px;
    }

    .pl-card {
        padding: 14px 16px;
    }

    .pl-card.net-profit {
        grid-column: 1 / -1;
    }

    .pl-card-value {
        font-size: 18px;
    }

    .pl-card.net-profit .pl-card-value {
        font-size: 22px;
    }

    /* Show mobile cards, hide table */
    .desktop-view {
        display: none !important;
    }

    .mobile-view {
        display: flex !important;
    }

    .records-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        padding: 12px;
    }

    .records-controls {
        width: 100%;
        justify-content: space-between;
    }

    .toggle-table-btn {
        padding: 4px 12px;
        font-size: 12px;
    }
}

@media (max-width: 480px) {
    .bank-app {
        padding: 8px;
    }

    .pl-grid {
        grid-template-columns: 1fr;
        gap: 8px;
    }

    .pl-card {
        padding: 12px 14px;
    }

    .pl-card.net-profit {
        grid-column: 1;
    }

    .pl-card-value {
        font-size: 16px;
    }

    .pl-card.net-profit .pl-card-value {
        font-size: 20px;
    }

    .record-card {
        padding: 12px 14px;
    }

    .card-value.title {
        font-size: 14px;
    }

    .card-label {
        font-size: 12px;
    }

    .card-value.amount {
        font-size: 13px;
    }

    .card-index {
        font-size: 12px;
    }

    .page-btn {
        padding: 4px 12px;
        font-size: 12px;
    }
}

/* Dark Mode Support */
[data-theme="dark"] .record-card {
    background: #1a1a2e;
}

[data-theme="dark"] .records-table tbody tr:hover {
    background: #2d2d44;
}

[data-theme="dark"] .type-income {
    background: #064e3b;
    color: #34d399;
}

[data-theme="dark"] .type-expense {
    background: #7f1d1d;
    color: #fca5a5;
}

[data-theme="dark"] .card-type-badge.type-income {
    background: #064e3b;
    color: #34d399;
}

[data-theme="dark"] .card-type-badge.type-expense {
    background: #7f1d1d;
    color: #fca5a5;
}

[data-theme="dark"] .error-state {
    background: #1c1917;
    border-color: #f59e0b;
}

[data-theme="dark"] .pl-card.net-profit {
    background: linear-gradient(135deg, #1a1a3e 0%, #1a1a2e 100%);
}

@keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

/* ===== SUMMARY CARD ===== */
.record-card.summary-card {
    background: #e2e2e2;
    border: 2px solid rgba(0, 0, 0, 0.12);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    transform: scale(1.02);
    position: relative;
    overflow: hidden;
}

.record-card.summary-card::before {
    content: '';
    position: absolute;
    top: -50%;
    right: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(0, 0, 0, 0.04) 0%, transparent 70%);
    pointer-events: none;
}

.record-card.summary-card .card-header.summary-header {
    border-bottom-color: rgba(0, 0, 0, 0.08);
    padding-bottom: 12px;
    margin-bottom: 12px;
}

.record-card.summary-card .summary-icon {
    color: #555555;
    font-size: 18px;
}

.record-card.summary-card .type-summary {
    background: #666666;
    color: white;
    font-weight: 700;
    padding: 4px 16px;
    font-size: 13px;
}

.record-card.summary-card .summary-title {
    color: #333333;
    font-size: 16px;
    font-weight: 700;
}

.record-card.summary-card .summary-label {
    color: rgba(0, 0, 0, 0.5);
    font-weight: 600;
}

.record-card.summary-card .summary-amount {
    font-size: 16px;
    font-weight: 700;
    color: #333333;
}

.record-card.summary-card .summary-balance {
    font-size: 18px;
    font-weight: 800;
}

.record-card.summary-card .summary-balance.positive-balance {
    color: #dc2626;
}

.record-card.summary-card .summary-balance.negative-balance {
    color: #16a34a;
}

.record-card.summary-card .summary-balance.zero-balance {
    color: #9ca3af;
}

.record-card.summary-card .summary-balance-row {
    border-top-color: rgba(0, 0, 0, 0.08);
    padding-top: 8px;
    margin-top: 6px;
}

/* Hover effect for summary card */
.record-card.summary-card:hover {
    transform: scale(1.03);
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12);
    transition: all 0.3s ease;
}

/* Summary card animations - subtle pulse */
.record-card.summary-card {
    animation: pulseGlow 2s ease-in-out infinite;
}

@keyframes pulseGlow {
    0%, 100% {
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    }
    50% {
        box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
    }
}

/* Responsive for summary card */
@media (max-width: 480px) {
    .record-card.summary-card {
        transform: scale(1.01);
        padding: 14px 12px;
    }
    
    .record-card.summary-card .summary-title {
        font-size: 14px;
    }
    
    .record-card.summary-card .summary-amount {
        font-size: 14px;
    }
    
    .record-card.summary-card .summary-balance {
        font-size: 16px;
    }
    
    .record-card.summary-card .type-summary {
        font-size: 11px;
        padding: 3px 12px;
    }
}

/* Dark mode support for summary card */
[data-theme="dark"] .record-card.summary-card {
    background: #2a2a2a;
    border-color: rgba(255, 255, 255, 0.12);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

[data-theme="dark"] .record-card.summary-card::before {
    background: radial-gradient(circle, rgba(255, 255, 255, 0.04) 0%, transparent 70%);
}

[data-theme="dark"] .record-card.summary-card .card-header.summary-header {
    border-bottom-color: rgba(255, 255, 255, 0.08);
}

[data-theme="dark"] .record-card.summary-card .summary-icon {
    color: #999999;
}

[data-theme="dark"] .record-card.summary-card .type-summary {
    background: #555555;
    color: white;
}

[data-theme="dark"] .record-card.summary-card .summary-title {
    color: #e5e5e5;
}

[data-theme="dark"] .record-card.summary-card .summary-label {
    color: rgba(255, 255, 255, 0.5);
}

[data-theme="dark"] .record-card.summary-card .summary-amount {
    color: #d4d4d4;
}

[data-theme="dark"] .record-card.summary-card .summary-balance.positive-balance {
    color: #f87171;
}

[data-theme="dark"] .record-card.summary-card .summary-balance.negative-balance {
    color: #34d399;
}

[data-theme="dark"] .record-card.summary-card .summary-balance.zero-balance {
    color: #6b7280;
}

[data-theme="dark"] .record-card.summary-card .summary-balance-row {
    border-top-color: rgba(255, 255, 255, 0.08);
}

[data-theme="dark"] .record-card.summary-card:hover {
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.5);
}

[data-theme="dark"] .record-card.summary-card {
    animation: pulseGlowDark 2s ease-in-out infinite;
}

@keyframes pulseGlowDark {
    0%, 100% {
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
    }
    50% {
        box-shadow: 0 4px 24px rgba(0, 0, 0, 0.5);
    }
}
</style>